import { defineMessages } from 'react-intl';

export default defineMessages({
  approvalModalTitle: {
    id: 'app.containers.OpeningApprovals.Approvals.approvalModalTitle',
    defaultMessage: 'Approve Opening',
  },
  rejectionModalTitle: {
    id: 'app.containers.OpeningApprovals.Approvals.rejectionModalTitle',
    defaultMessage: 'Add Rejection Reason',
  },
  approvalModalSubtitle: {
    id: 'app.containers.OpeningApprovals.Approvals.approveSubtitle',
    defaultMessage: 'Are you sure you want to approve this opening?',
  },
  rejectionModalSubtitle: {
    id: 'app.containers.OpeningApprovals.Approvals.rejectionSubtitle',
    defaultMessage: 'Leave a note for why you are rejecting this opening.',
  },
  approve: {
    id: 'app.containers.OpeningApprovals.Approvals.approve',
    defaultMessage: 'Approve',
  },
  reject: {
    id: 'app.containers.OpeningApprovals.Approvals.reject',
    defaultMessage: 'Reject',
  },
  approveAll: {
    id: 'app.containers.OpeningApprovals.Approvals.approveAll',
    defaultMessage: 'Approve all',
  },
  rejectAll: {
    id: 'app.containers.OpeningApprovals.Approvals.rejectAll',
    defaultMessage: 'Reject all',
  },
  rejectionReason: {
    id: 'app.containers.OpeningApprovals.Approvals.rejectionReason',
    defaultMessage: 'Rejection Reason',
  },
  approvalRule: {
    id: 'app.containers.OpeningApprovals.Approvals.approvalRule',
    defaultMessage: 'Approval rule',
  },
  approverRule: {
    id: 'app.containers.OpeningApprovals.Approvals.approverRule',
    defaultMessage: 'Approver rule',
  },
  approvalStatus: {
    id: 'app.containers.OpeningApprovals.Approvals.approvalStatus',
    defaultMessage: 'Approval Status',
  },
  approvalAction: {
    id: 'app.containers.OpeningApprovals.Approvals.approvalAction',
    defaultMessage: 'Approval Action',
  },
  noApprovalsFound: {
    id: 'app.containers.OpeningApprovals.Approvals.noApprovalsFound',
    defaultMessage: 'No Approvals found.',
  },
  selected: {
    id: 'app.containers.OpeningApprovals.Approvals.selected',
    defaultMessage: '{count} selected',
  },
  rejectionPlaceholder: {
    id: 'app.containers.OpeningApprovals.Approvals.rejectionPlaceholder',
    defaultMessage:
      'ex. The pay rate is incorrect. This position’s pay rate is $17.80/hr',
  },
  approved: {
    id: 'app.containers.OpeningApprovals.Approvals.approved',
    defaultMessage: 'Approved',
  },
  pending: {
    id: 'app.containers.OpeningApprovals.Approvals.pending',
    defaultMessage: 'Pending',
  },
  rejected: {
    id: 'app.containers.OpeningApprovals.Approvals.rejected',
    defaultMessage: 'Rejected',
  },
  openingApprovalNotFound: {
    id: `app.containers.OpeningApprovals.Approvals.openingApprovalNotFound`,
    defaultMessage:
      'Approval request not found. It may have been canceled or is no longer available.',
  },
  approvalRequiredModalTitle: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredModalTitle`,
    defaultMessage: 'Approval Required',
  },
  approvalRequiredModalDescription: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredModalDescription`,
    defaultMessage:
      "You've made the following changes to this active opening. These changes will need to be approved before they will be updated to the active opening.",
  },
  approvalRequiredModalSubmit: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredModalSubmit`,
    defaultMessage: 'Submit for Approval',
  },
  approvalRequiredReasonForChange: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredReasonForChange`,
    defaultMessage: 'Reason for change',
  },
  approvalRequiredReasonPlaceholder: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredReasonPlaceholder`,
    defaultMessage: 'Please enter details for the changes made',
  },
  approvalRequiredOpeningApprovers: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredOpeningApprovers`,
    defaultMessage: 'Opening Approvers',
  },
  approvalRequiredNumberOfHires: {
    id: `app.containers.OpeningApprovals.Approvals.approvalRequiredNumberOfHires`,
    defaultMessage: '{count, plural, one {{count} hire} other {{count} hires}}',
  },
});
